<template>
  <div class="home-container">
    <section class="overview-heading"><div><span class="eyebrow">你的工作空间</span><h1>文件有序，灵感随行。</h1><p>从这里开始，管理、查找和分享你的文件。</p></div><span class="overview-badge"><i class="el-icon-folder-opened"></i> 每一份文件，都有自己的位置</span></section>
    <section class="welcome-banner">
      <div class="welcome-copy"><span class="banner-label">把好想法，放在一起</span><h2>重要的文件，<br>触手可及。</h2><p>拖入文件，选好分类。<br>让日常整理变得轻松一点。</p><router-link to="/file/upload" class="banner-button"><i class="el-icon-plus"></i> 上传新文件 <i class="el-icon-right"></i></router-link></div>
      <div class="file-illustration" aria-hidden="true"><div class="illustration-orbit"></div><div class="illustration-folder"><span></span><i class="el-icon-folder-opened"></i></div><div class="floating-file floating-pdf"><i class="el-icon-document"></i><span>PDF</span></div><div class="floating-file floating-image"><i class="el-icon-picture-outline"></i><span>IMAGE</span></div><div class="illustration-dot dot-one"></div><div class="illustration-dot dot-two"></div></div>
    </section>
    <section class="workspace-shortcuts" aria-label="快捷操作">
      <router-link to="/file/my-files" class="workspace-shortcut"><span class="shortcut-symbol blue"><i class="el-icon-folder"></i></span><div><h3>我的文件</h3><p>整理与管理个人文件</p></div><i class="el-icon-top-right"></i></router-link>
      <router-link to="/file/shared" class="workspace-shortcut"><span class="shortcut-symbol green"><i class="el-icon-connection"></i></span><div><h3>共享中心</h3><p>发现团队共享的内容</p></div><i class="el-icon-top-right"></i></router-link>
      <router-link to="/file/recycle" class="workspace-shortcut"><span class="shortcut-symbol amber"><i class="el-icon-delete"></i></span><div><h3>回收站</h3><p>找回误删的文件</p></div><i class="el-icon-top-right"></i></router-link>
    </section>
    <section class="recent-files card">
      <div class="section-title"><div><h2>最近上传</h2><p>接着上次的工作，继续前行。</p></div><router-link to="/file/my-files" class="section-link">查看全部 <i class="el-icon-right"></i></router-link></div>
      <div v-if="loadError" class="inline-error" role="alert"><i class="el-icon-warning-outline"></i> 最近文件暂时加载失败。<el-button type="text" @click="fetchRecentFiles">重新加载</el-button></div>
      <el-table v-else :data="recentFiles" v-loading="loading">
        <el-table-column prop="fileName" label="文件名称" min-width="260"><template slot-scope="scope"><file-identity :name="scope.row.fileName" /></template></el-table-column>
        <el-table-column label="大小" width="120"><template slot-scope="scope">{{ formatFileSize(scope.row.fileSize) }}</template></el-table-column>
        <el-table-column prop="createTime" label="上传时间" width="170"><template slot-scope="scope">{{ formatTime(scope.row.createTime) }}</template></el-table-column>
        <el-table-column label="操作" width="100"><template slot-scope="scope"><file-download-with-progress :file-id="scope.row.id" :file-name="scope.row.fileName" :file-size="scope.row.fileSize" /></template></el-table-column>
        <div slot="empty" class="workspace-empty"><span class="empty-icon"><i class="el-icon-folder-opened"></i></span><h3>空间已准备好</h3><p>上传第一份文件，让工作从这里开始。</p><router-link to="/file/upload" class="section-link">上传文件 <i class="el-icon-right"></i></router-link></div>
      </el-table>
    </section>
  </div>
</template>

<script>
import { getRecentFiles } from '@/api/file'
import { formatFileSize } from '@/utils/format'
import FileDownloadWithProgress from '@/components/FileDownloadWithProgress'
import FileIdentity from '@/components/FileIdentity'

export default {
  name: 'Home',
  components: { FileDownloadWithProgress, FileIdentity },
  data() { return { recentFiles: [], loading: false, loadError: false } },
  created() { this.fetchRecentFiles() },
  methods: {
    formatFileSize,
    async fetchRecentFiles() {
      this.loading = true
      this.loadError = false
      try {
        const result = await getRecentFiles({ size: 5 })
        if (result.code !== 200) throw new Error(result.message)
        this.recentFiles = result.data || []
      } catch (_) { this.loadError = true }
      finally { this.loading = false }
    },
    formatTime(time) {
      if (!time) return '—'
      return new Date(time).toLocaleDateString('zh-CN', { month: 'short', day: 'numeric' })
    }
  }
}
</script>
